import type { DocumentUiState } from '../constants'

import { defineStore } from 'pinia'
import { ref } from 'vue'

import { documentUiStates } from '../constants'
import type { ExternalLinkAttributes } from '@app/application/reconciliation/types'

export const useDocumentUploadStore = defineStore('documentUpload', () => {
  const activeState = ref<DocumentUiState>(documentUiStates.INITIAL)
  const externalLink = ref<ExternalLinkAttributes>()

  const activateState = (state: DocumentUiState): void => {
    activeState.value = state
  }

  const setExternalLinkAttributes = (
    name: string,
    url: string,
    id: string
  ): void => {
    externalLink.value = {
      name,
      url,
      id,
    }
  }

  const clearExternalLinkAttributes = (): void => {
    externalLink.value = undefined
  }

  return {
    activeState,
    activateState,
    externalLink,
    setExternalLinkAttributes,
    clearExternalLinkAttributes,
  }
})
